import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StatisticsTileComponent } from './statistics-tile.component';
import { FlexLayoutModule } from '@angular/flex-layout';

@NgModule({
  declarations: [StatisticsTileComponent],
  imports: [CommonModule, FlexLayoutModule],
  exports: [StatisticsTileComponent],
})
export class StatisticsTileModule {}
